<template>
  <div>
    <h1 class="mb-5">Candidate Feedback</h1>
    <span class="secondary-text">
      Feedback for the candidate on their interview performance
    </span>
    <v-textarea
      v-model="candidateFeedback"
      @change="handleChange"
      height="200"
      color="primary"
    />
  </div>
</template>

<script>
export default {
  props: {
    feedback: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      candidateFeedback: this.feedback ? this.feedback.candidateFeedback : ""
    };
  },
  methods: {
    handleChange() {
      this.$emit("onChange", { candidateFeedback: this.candidateFeedback });
    }
  }
};
</script>

<style lang="scss"></style>
